import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getServiceReviews = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/service_reviews', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getServiceReview = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/service_reviews/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeServiceReview = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/service_reviews', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateServiceReview = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/service_reviews/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteServiceReview = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/service_reviews/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchServiceReviews = async (term, token) => (
	fetch( getDomain()+`/service_reviews?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)